import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { SlackNotificationService } from '../services/slack-notification.service';
import { urlModifiedWithVersion } from '../static-methods/modifyJsonUrl';
import { CustomErrorHandler } from '../modules/error-logging/CustomErrorHandler';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private readonly slackNotificationService: SlackNotificationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Check if the request URL is for a JSON file (e.g., i18n files)
        if (request.url.includes('/assets/i18n/')) {
            const path = urlModifiedWithVersion(request.url);
            request = request.clone({ url: path });
        }

        // Pass through unmodified requests for non-JSON files
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (CustomErrorHandler.ignoreError(error) === false) {
                    if (this.isClaimOrderRequest(request)) {
                        this.slackNotificationService
                            .sendErrorAlertWithRaw(error, 'DataBeast API Error : Search ClaimOrder')
                            .subscribe();
                    } else if (this.isGetUilmFileRequest(request)) {
                        this.slackNotificationService
                            .sendErrorAlertWithRaw(error, `UILM API Error : Module(${this.getModuleName(request.url)})`)
                            .subscribe();
                    }
                    // if the request method is POST and there is a body then we'll just send specific error
                    else if (request.method === 'POST' && request.body && error.error !== 'message_limit_exceeded') {
                        this.slackNotificationService.sendHttpErrorMessageWithBody(error, request).subscribe();
                    }
                }

                // we are returning all the error except the ignore list, only specified error was thrown in the previous version
                return throwError(() => error);
            })
        );
    }

    private isClaimOrderRequest(request: HttpRequest<any>): boolean {
        return request.url.toLowerCase().includes('claimorder');
    }

    private isGetUilmFileRequest(request: HttpRequest<any>): boolean {
        const url = request.url.toLowerCase();
        return url.includes('getuilmfile');
    }
    private getModuleName(url: string): string | null {
        const params = new URL(url).searchParams;
        return params.get('ModuleName');
    }
}
